<template>
    <b-container fluid="">
        <b-row>
            <div class="col-sm-12 mt-1">
                <h3>
                    Entradas
                </h3>
            </div>
            <!-- entrada por no factura, dte, proveedor, producto, precio_unitario, cantidad -->
            <div class="col-sm-3 mt-2">
                <label for="" class="form-label">DTE</label>
                <input type="text" class="form-control form-control-sm" v-model="dte">
            </div>

            <div class="col-sm-3 mt-2">
                <label for="" class="form-label">Proveedor</label>
                <select class="form-control form-control-sm" v-model="proveedor">
                    <option value="">Seleccionar proveedor</option>
                    <option value="0">Sin proveedor</option>
                    <option v-for="(item, index) in proveedores_" :key="index" :value="item.id">{{ item.nombre_proveedor
                    }}</option>
                </select>
            </div>

            <div class="col-sm-3 mt-2">
                <label for="" class="form-label">Fecha de factura</label>
                <input type="date" class="form-control form-control-sm" v-model="fecha_factura">
            </div>

            <div class="col-sm-3 mt-2">
                <label for="" class="form-label">Motivo Entrada</label>
                <select class="form-control form-control-sm" v-model="motivo">
                    <option value="">Seleccionar motivo</option>
                    <option v-for="(item, index) in motivos_entrada" :key="index" :value="item.id">{{ item.motivo }}
                    </option>
                </select>
            </div>

            <div class="col-sm-6 mt-3">
                <label for="" class="form-label">Código producto</label>
                <input type="text" id="campo_codigo_producto" list="productos_" class="form-control form-control-sm"
                    placeholder="Doble click para buscar" v-model="codigo_producto"
                    @keydown.tab="consulta_de_producto_por_codigo" @change="consulta_de_producto_por_codigo"
                    @dblclick="abrir_modal_de_busqueda_de_productos">
                <!-- <datalist id="productos_">
                    <option v-for="(item, index) in FILTRAR_PRODUCTOS_POR_SUCURSAL" :key="index" :value="item.codigo">{{
                        item.nombre
                    }}</option>
                </datalist> -->
            </div>

            <div class="col-sm-2 mt-3">
                <label for="" class="form-label">Precio</label>
                <input type="text" id="campo_precio_unitario_entradas" class="form-control form-control-sm" v-model="precio_unitario">
            </div>

            <div class="col-sm-2 mt-3">
                <label for="" class="form-label">Cantidad</label>
                <input type="number" min="1" class="form-control form-control-sm" v-model="cantidad">
            </div>

            <div class="col-sm-2 mt-5">
                <button v-if="codigo_producto != ''" type="button" @click="agregar_elemento_al_listado"
                    class="btn btn-sm btn-dark btn-block"><i class="fas fa-plus"></i></button>
                <button v-else type="button" disabled class="btn btn-sm btn-dark btn-block"><i
                        class="fas fa-plus"></i></button>
            </div>

            <div class="col-sm-12 mt-3">
                <div class="contenedor_texto_articulo">
                    {{ nombre_producto }}
                </div>
            </div>

            <div class="col-sm-12 mt-3">
                <div class="marco_lista_compras">

                    <table class="table table-sm table-striped table-bordered" style="font-size: 11px;">
                        <thead>
                            <tr>
                                <th style="width: 15%;text-align: center;">
                                    Código
                                </th>
                                <th style="width: 40%;">
                                    Nombre
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    P.Unitario
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    Cantidad
                                </th>
                                <th style="width: 15%;text-align: center;">
                                    Sub total
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    ...
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in listado" :key="index">
                                <td style="text-align: center;">
                                    {{ item.codigo }}
                                </td>
                                <td>
                                    {{ item.nombre }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.precio_unitario }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.cantidad }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.sub_total }}
                                </td>
                                <td style="text-align: center;">
                                    <b-button type="button" size="sm" style="font-size: 10px;" variant="outline-danger"
                                        @click="eliminar_elemento_del_listado(index)"><i
                                            class="fas fa-trash"></i></b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-sm-8 mt-3">
                <div class="contenedor_texto_articulo">
                    TOTAL: {{ gran_total }}
                </div>
            </div>

            <div class="col-sm-4 mt-3">
                <button v-if="permisos['inventarios.movimientos.entradas']?.crear || ES_ROOT" type="button"
                    class="btn btn-sm btn-outline-dark btn-block" @click="guardar_entradas">Guardar</button>
                <button v-else type="button" class="btn btn-sm btn-outline-dark btn-block" disabled>Guardar</button>
            </div>

            <button type="button" id="btn_flotante_configuracion" class="btn btn-sm btn-outline-dark"
                v-if="permisos['inventarios.movimientos.entradas.motivos']?.ver || datos_usuario.parametros.roles.includes('ROOT')"
                @click="abrir_modal_crear_motivo">
                <i class="fas fa-cog"></i>
            </button>
            <button type="button" id="btn_flotante_configuracion" class="btn btn-sm btn-outline-dark" v-else disabled>
                <i class="fas fa-cog"></i>
            </button>
        </b-row>

        <Muestra v-if="modal_crear_motivo" v-on:salir="cerrar_modal_crear_motivo" />
        <ModalBusqueda v-if="modal_buscar_productos" v-on:colocar="colocar_resultados_de_busqueda" />

    </b-container>
</template>

<script>
import { minix } from '@/components/functions/alertas';
import moment from 'moment';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Muestra from './Motivos/Muestra.vue'
import ModalBusqueda from '@/components/Inventario/Movimientos/Entradas/ModalBusquedaProductos.vue';

export default {
    name: 'Entrada',
    computed: {
        ...mapState(['sucursal_seleccionada', 'permisos', 'datos_usuario', 'proveedores_', 'id_empresa_seleccionada', 'motivos_entrada', 'modal_buscar_productos', 'articulo_busqueda_seleccionado']),
        ...mapGetters(['ES_ROOT', 'FILTRAR_PRODUCTOS_POR_SUCURSAL'])
    },
    components: {
        Muestra,
        ModalBusqueda
    },
    data() {
        return {
            dte: '',
            proveedor: '',
            fecha_factura: moment(Date.now()).format('YYYY-MM-DD'),
            codigo_producto: '',
            nombre_producto: '-',
            precio_unitario: '',
            cantidad: 1,
            listado: [],
            gran_total: 0,
            sucursal: '',
            motivo: '',
            existe: false,
            modal_crear_motivo: false
        }
    },
    methods: {
        async consulta_de_producto_por_codigo() {

            if (this.codigo_producto.trim() == '') {

                console.log('No hay codigo de producto')

            } else {
                let f = {
                    api: `articulos?filters[codigo][$eq][0]=${this.codigo_producto.trim()}&filters[sucursal][$eq][1]=0&filters[formula][$eq][2]=false&filters[empresa][$eq][3]=${this.id_empresa_seleccionada}`,
                    // notificacion: { mensaje: 'Producto no encontrado' }
                }

                let r = await this.obtener_data(f)

                if (r.length != 0) {

                    this.existe = true
                    this.codigo_producto = r[0].codigo
                    this.nombre_producto = r[0].nombre
                    this.precio_unitario = r[0].precio_costo

                } else {
                    this.existe = false

                }

            }

        },
        colocar_resultados_de_busqueda() {
            this.existe = true
            this.codigo_producto = this.articulo_busqueda_seleccionado.codigo//r[0].codigo
            this.nombre_producto = this.articulo_busqueda_seleccionado.nombre//r[0].nombre
            this.precio_unitario = this.articulo_busqueda_seleccionado.precio_costo//r[0].precio_costo
            document.getElementById('campo_precio_unitario_entradas').focus()
        },
        eliminar_elemento_del_listado(index) {
            this.listado.splice(index, 1)
            let contador = 0

            for (let i = 0; i < this.listado.length; i++) {
                const e = this.listado[i];

                contador += e.sub_total

            }

            this.gran_total = contador
        },

        agregar_elemento_al_listado() {
            if (this.codigo_producto == '' || this.nombre_producto == '' || this.precio_unitario == '' || this.cantidad == '') {

                minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })

            } else {

                if (this.cantidad <= 0 || this.precio_unitario <= 0) {
                    minix({ icon: 'error', mensaje: 'Los valores no pueden ser negativos o cero', tiempo: 3000 })

                } else {

                    if (this.existe) {
                        let f = {
                            codigo: this.codigo_producto.trim(),
                            nombre: this.nombre_producto,
                            precio_unitario: this.precio_unitario,
                            cantidad: this.cantidad,
                            sub_total: this.precio_unitario * this.cantidad
                        }

                        this.listado.push(f)

                        let contador = 0

                        for (let i = 0; i < this.listado.length; i++) {
                            const e = this.listado[i];

                            contador += e.sub_total

                        }

                        this.gran_total = contador

                        this.codigo_producto = ''
                        this.nombre_producto = '-'
                        this.precio_unitario = ''
                        this.cantidad = 1

                        document.getElementById('campo_codigo_producto').focus()

                    } else {
                        minix({ icon: 'error', mensaje: 'El producto no existe', tiempo: 3000 })
                        document.getElementById('campo_codigo_producto').focus()
                    }


                }

            }

        },
        async guardar_entradas() {

            if (this.dte == '' || this.proveedor == '' || this.listado.length == 0) {
                minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
            } else {

                let f = {
                    api: `movimientos-cabeceras/g/entradas`,
                    formulario: {
                        dte: this.dte,
                        proveedor: this.proveedor,
                        fecha_factura: this.fecha_factura,
                        total_movimiento: this.gran_total,
                        listado: this.listado
                    }
                }

                await this.guardar_data(f)
                this.gran_total = 0
                this.listado = []
                this.dte = ''
                this.cantidad = 1
                this.proveedor = ''
            }

        },
        abrir_modal_de_busqueda_de_productos() {
            this.set_modal_buscar_productos(true)
        },
        setear_sucursal_origen() {
            // ESTO ES PARA QUE FILTRE LOS PRODUCTOS POR SUCURSAL
            this.set_filtro_productos_sucursales_traslados(parseInt(this.sucursal))

        },
        ...mapActions(['set_filtro_productos_sucursales_traslados']),
        ...mapActions(['obtener_data', 'guardar_data', 'obtener_motivos_entradas']),
        ...mapMutations(['set_modal_buscar_productos']),
        abrir_modal_crear_motivo() {
            this.modal_crear_motivo = true
        },
        cerrar_modal_crear_motivo() {
            this.modal_crear_motivo = false
        }
    },
    mounted() {
        this.obtener_motivos_entradas()
    },
}
</script>

<style>
.contenedor_texto_articulo {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #535354;
    border: 1px solid #e9e9e9;
    border-radius: 5px;
}

.marco_lista_compras {
    border: 1px solid #e9e9e9;
    width: 100%;
    height: calc(100vh - 440px);
    overflow: auto;
}

#btn_flotante_configuracion {
    position: fixed;
    top: 100px;
    right: 20px;
    z-index: 999;
}
</style>
